import React, { useRef, useEffect } from 'react'
import injectStyles from 'react-jss'
import moment from 'moment'
import GenericFlatButton from '../../GenericFlatButton'
import CloseIcon from 'Assets/Images/icons/modalClose'
import { styles } from '../ActionModals/styles'
import { CONTRACT_TYPE_TO_NAME_MAP } from '../../../shared/constants'

const ContractDataModal = ({ contractData, ambassador, onClose, classes }) => {
  const { firstName, lastName, email, mobilePhone, dateOfBirth } = ambassador
  const {
    createdAt: signedOn,
    startDate,
    postalCode,
    address,
    hoursPerWeek,
    contractType,
    reSignedAt,
    houseNumber,
    exactAddress,
    city,
    state,
    nationality,
    preferredWorkDuration,
    currentEmploymentStatus,
    previousWork,
  } = contractData

  const ModalItem = ({ label, value, containerStyle }) => {
    return (
      <div className={classes.modalItemWrapper} style={containerStyle}>
        <div className={classes.itemTitle}>{label}</div>
        <div className={classes.itemValue}>{value}</div>
      </div>
    )
  }

  const modalRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = event => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose()
      }
    }

    const handleEscapeKeyPress = event => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleEscapeKeyPress)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscapeKeyPress)
    }
  }, [onClose])

  const formatedAddress = `${address}${houseNumber ? `, ${houseNumber}` : ''}${
    exactAddress ? `, ${exactAddress}` : ''
  }`

  return (
    <div className={classes.modalContainer} ref={modalRef}>
      <div className={classes.nmbrsModalTitle}>Contract Data</div>
      <span className={classes.close} onClick={onClose}>
        <CloseIcon />
      </span>
      <div className={classes.modalDataWrapper}>
        <div className={classes.modalRow}>
          <ModalItem label={'Name'} value={`${firstName} ${lastName}`} />
          <ModalItem
            label={'Birthdate'}
            value={moment.utc(dateOfBirth).format('DD MMM YYYY')}
          />
          <ModalItem label={'Phone number'} value={mobilePhone} />
          {nationality && (
            <ModalItem label={'Nationality'} value={nationality} />
          )}
        </div>

        <div className={classes.modalRow}>
          <ModalItem
            label={'Email'}
            value={email}
            containerStyle={{ width: '100%' }}
          />
        </div>
        <div className={classes.divider} />
        <div className={classes.modalRow}>
          <ModalItem label={'Address'} value={formatedAddress} />
          {city && <ModalItem label={'City'} value={city} />}
          {state && <ModalItem label={'State'} value={state} />}
          <ModalItem label={'Postcode'} value={postalCode} />
        </div>
        <div className={classes.modalRow}>
          <ModalItem label={'Signed on'} value={reSignedAt || signedOn} />
        </div>
        <div className={classes.divider} />
        <div className={classes.modalRow}>
          <ModalItem
            label={'Type of contract'}
            value={CONTRACT_TYPE_TO_NAME_MAP[contractType]}
          />
          <ModalItem label={'Hours per week'} value={hoursPerWeek} />
          {preferredWorkDuration && (
            <ModalItem
              label={'Preferred work duration'}
              value={preferredWorkDuration}
            />
          )}
        </div>
        <div className={classes.modalRow}>
          <ModalItem label={'Start date'} value={startDate} />
          {currentEmploymentStatus && (
            <ModalItem
              label={'Current employment status'}
              value={currentEmploymentStatus}
              containerStyle={{ width: '70%' }}
            />
          )}
        </div>
        {previousWork ? (
          <div>
            <div className={classes.nmbrsModalTitle}>
              Previous jobs on this year
            </div>
            {previousWork.map((job, index) => {
              return (
                <div>
                  <div className={classes.modalSectionSubtitle}>{`Job №${index +
                    1}`}</div>

                  <div className={classes.modalRow}>
                    <ModalItem label={'Company name'} value={job.companyName} />
                    <ModalItem
                      label={'Contract type'}
                      value={job.contractType}
                    />
                    <ModalItem
                      label={'Hours per day'}
                      value={job.hoursPerDay}
                    />
                  </div>
                  <div className={classes.modalRow}>
                    <ModalItem
                      label={'Days per week'}
                      value={job.daysPerWeek}
                    />
                    <ModalItem label={'Start date'} value={job.startDate} />
                    <ModalItem label={'End date'} value={job.endDate} />
                  </div>
                </div>
              )
            })}
          </div>
        ) : null}
      </div>
      <div className={classes.cancelButton}>
        <GenericFlatButton type={'outline'} title={'Close'} onClick={onClose} />
      </div>
    </div>
  )
}

export default injectStyles(styles)(ContractDataModal)
